const steps = {
  profile: 0,
  calendar: 1,
  calendarAdded: 2,
  calendarSelection: 3,
  desktop: 4,
  desktopAdded: 5,
  health: 6,
  healthAdded: 7,
  checklist: 8,
  done: 9,
};

export default steps;
